module.exports = __webpack_public_path__ + "static/media/venom-hited.0acd3de9.png";